"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationPlatformActivity',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        campaignType: 'platform'
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        submit: '提交',
        activate: '投放',
        pause: '暂停',
        resume: '恢复',
        complete: '结束',
        cancel: '取消'
      }[value] || value;
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationCampaignListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('活动名称', '承接平台活动').then(function (_ref) {
        var value = _ref.value;
        var now = new Date();
        var pad = function pad(n) {
          return String(n).padStart(2, '0');
        };
        var start = "".concat(now.getFullYear(), "-").concat(pad(now.getMonth() + 1), "-").concat(pad(now.getDate()), " ").concat(pad(now.getHours()), ":").concat(pad(now.getMinutes()), ":00");
        var endDate = new Date(Date.now() + 7 * 24 * 3600 * 1000);
        var end = "".concat(endDate.getFullYear(), "-").concat(pad(endDate.getMonth() + 1), "-").concat(pad(endDate.getDate()), " 23:59:59");
        (0, _decoration.decorationCampaignSaveApi)({
          name: value || 'E2E平台活动',
          campaignType: 'platform',
          sourcePlatformCampaignId: 90001,
          budget: 0,
          startTime: start,
          endTime: end
        }).then(function () {
          _this2.$message.success('已承接');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationCampaignActionApi)(row.campaign.id, {
          action: action
        }).then(function () {
          _this3.$message.success('已更新');
          _this3.loadCurrent();
        });
      }).catch(function () {});
    }
  }
};